<div class="container-fluid p-h-0 p-v-20 h-100 bg" style="background-image: url('assets/images/others/login-3.png')">
    <div class="d-flex flex-column justify-content-between h-100">
        <div class="d-none d-md-block"></div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-7 col-lg-5 m-h-auto">
                    <nz-card class="m-b-100 shadow-lg">
                        <div class="d-flex align-items-center justify-content-between m-b-30">
                            <img class="img-fluid" alt="" src="assets/images/logo/logo.png">
                            <h2 class="m-b-0">Sign In</h2>
                        </div>
                        <form nz-form [formGroup]="loginForm" nzLayout="vertical" class="login-form" (ngSubmit)="submitForm()">
                            <nz-form-item>
                                <nz-form-label nzRequired nzFor="userName">Email</nz-form-label>
                                <nz-form-control nzErrorTip="Please input your email!">
                                    <nz-input-group [nzPrefix]="prefixUser">
                                        <input type="text" nz-input formControlName="userEmail" placeholder="Email">
                                    </nz-input-group>
                                </nz-form-control>
                            </nz-form-item>
                            <nz-form-item class="relative">
                                <nz-form-label nzRequired nzFor="password">Password</nz-form-label>
                                <a class="float-right font-size-13 text-muted" style="position:absolute; right: 0" [routerLink]="['/authentication/reset-password-1']">Forget Password?</a>
                                <nz-form-control nzErrorTip="Please input your Password!">
                                    <nz-input-group [nzPrefix]="prefixLock">
                                        <input type="password" nz-input formControlName="password" placeholder="Password">
                                    </nz-input-group>
                                </nz-form-control>
                            </nz-form-item>
                            <nz-form-item>
                                <nz-form-control>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <span class="font-size-13 text-muted"><!--Don't have an account? <a class="small" [routerLink]="['/authentication/sign-up']"> Signup</a>--></span>
                                        <button nz-button class="login-form-button" [nzType]="'primary'">Sign In</button>
                                    </div>
                                </nz-form-control>
                            </nz-form-item>
                        </form>
                        <ng-template #prefixUser><i nz-icon nzType="user"></i></ng-template>
                        <ng-template #prefixLock><i nz-icon nzType="lock"></i></ng-template>
                    </nz-card>
                </div>
            </div>
        </div>
        <div class="d-none d-md-flex p-h-40 justify-content-between">
            <span class="">© 2025 Adpedia</span>
            <ul class="list-inline">
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Legal</a>
                </li>
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Privacy</a>
                </li>
            </ul>
        </div>
    </div>
</div>